import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DashInsteadOfNullPipe } from './dash-instead-of-null.pipe';
import { NegativeValueToBracesPipe } from './negative-value-to-braces.pipe';

@Pipe({
  name: 'numberDashBraces',
})
export class NumberDashBracesPipe implements PipeTransform {
  transform(value: any, numbs: string): string {
    const number = new DecimalPipe('en-US').transform(value, numbs);
    const bracedValue = new NegativeValueToBracesPipe().transform(number);
    const finalValue = new DashInsteadOfNullPipe().transform(bracedValue);

    return finalValue;
  }
}
